// state: El state es reactivo y cuando se cambie vamos a notificar a todos los componentes que estén escuchando los cambios del state
export default () => ({
    hits: 0,
    errors: 0
})